import { DEFAULT_CONFIG } from './constants';
import { getTrust } from './runtime';

const protectedEngines = new WeakMap();
let fallbackSequence = 0;

const unavailable = (checkpoint) => ({
  trusted: false,
  score: 0,
  threshold: DEFAULT_CONFIG.trustedScore,
  reasons: ['assessmentUnavailable'],
  evidence: [],
  coverage: 'limited',
  signals: {},
  assessmentId: `unavailable-${++fallbackSequence}`,
  checkpoint,
  evaluatedAt: Date.now(),
  version: 2,
});

const fallback = {
  scope: 'trust-unavailable',
  storageKey: undefined,
  check: (context, checkpoint = 'beforeConfirm') => unavailable(checkpoint),
  evaluate: (context, checkpoint = 'navigation') => unavailable(checkpoint),
  start: () => {},
  stop: () => {},
  record: () => {},
  booking: () => {},
  observeResult: () => {},
  prepareContact: () => {},
  visibility: () => {},
  refresh: () => {},
  isActive: () => false,
  getAssessment: () => undefined,
  getSummary: () => ({}),
};

const getSafeTrust = (store) => {
  try {
    const engine = getTrust(store);
    if (!protectedEngines.has(engine)) {
      const protectedEngine = { scope: engine.scope, storageKey: engine.storageKey };
      Object.keys(fallback)
        .filter((method) => typeof fallback[method] === 'function')
        .forEach((method) => {
          protectedEngine[method] = (...args) => {
            try {
              const result = engine[method](...args);
              if (method === 'prepareContact') return Promise.resolve(result).catch(() => undefined);
              if (['check', 'evaluate'].includes(method) && typeof result?.trusted !== 'boolean')
                return fallback[method](...args);
              return result;
            } catch {
              return fallback[method](...args);
            }
          };
        });
      protectedEngines.set(engine, protectedEngine);
    }
    return protectedEngines.get(engine);
  } catch {
    return fallback;
  }
};

export { getSafeTrust };
